export default {
  title: 'Pack Films',
  videos: 'Films de la collection',
  descriptionPrefix: 'Collection film et série : '
}
